import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NotFoundComponent } from '../../shared/components/not-found/not-found.component';

import { SharedModule } from '../../shared/shared.module';
import { PublicTopNavComponent } from './navs/public-top-nav/public-top-nav.component';
import { PublicAreaComponent } from './public-area.component';

const routes: Routes = [
  {
    path: '',
    component: PublicAreaComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./landing/landing.module').then((m) => m.LandingModule),
      },
      {
        path: 'user',
        loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'utils',
        loadChildren: () => import('./utils/utils.module').then((m) => m.UtilsModule),
      },
      {
        path: '**',
        component: NotFoundComponent,
        data: { type: 'public' },
      },
    ],
  },
];

@NgModule({
  imports: [SharedModule, RouterModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: [PublicAreaComponent, PublicTopNavComponent],
})
export class PublicAreaModule {}
